import React, { useState }from 'react';
import { useEffect } from 'react';

const Consent = ({privacyPolicyUrl, handleConsent, consentError}) => {
    const [errorClass, setErrorClass] = useState("");

    useEffect(() => {
        !consentError ? setErrorClass("") : setErrorClass("error");
      }, [consentError]);  

    return (
        <label className={`checkbox-text ${errorClass}`}>
            {`Send me this newsletter. I understand that Healthline will not sell my 
                email address and that I can unsubscribe at any time per the `}
            <a
                href={privacyPolicyUrl}
                target="_blank"
                className={`privacy-text ${errorClass}`}
                rel="noreferrer"
            >
                <span className="privacy policy">privacy policy.</span>
            </a>

            <input type='checkbox'
                className='checkbox'
                id='consent-checkbox'
                name='Consent'
                value='Consent'
                onClick={() => handleConsent()}
            />

            <span className={`checkmark ${errorClass}`}></span>
        </label>
    )
}

export default Consent;